import "./styles.css";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { Select, MenuItem, FormControlLabel } from "@mui/material";

const items = ["1", "2", "3", "4"];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 100,
    },
  },
};

export default function RecurringEvent({
  repeatWeek,
  onRepeatChange,
  daysSelected,
  onDaysSelected,
}) {
  const { Mo, Tu, We, Th, Fr, Sa, Su } = daysSelected;

  return (
    <>
      <div className="recurring-event-container" id="recurring-event-container">
        <div
          className="weekly-container"
          style={{ border: "1px solid rgba(169,169,169)" }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={Mo}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="Mo"
              />
            }
            label="Mo"
            labelPlacement="bottom"
            id="recurring-event-monday"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Tu}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="Tu"
              />
            }
            label="Tu"
            labelPlacement="bottom"
            id="recurring-event-tuesday"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={We}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="We"
              />
            }
            label="We"
            labelPlacement="bottom"
            id="recurring-event-wednesday"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Th}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="Th"
              />
            }
            label="Th"
            labelPlacement="bottom"
            id="recurring-event-thursday"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Fr}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="Fr"
              />
            }
            label="Fr"
            labelPlacement="bottom"
            id="recurring-event-friday"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Sa}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="Sa"
              />
            }
            label="Sa"
            labelPlacement="bottom"
            id="recurring-event-saturday"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Su}
                onChange={(event) =>
                  onDaysSelected(event.target.name, event.target.checked)
                }
                name="Su"
              />
            }
            label="Su"
            labelPlacement="bottom"
            id="recurring-event-sunday"
          />
        </div>
        <div className="repeat-container" id="repeat-picker-container">
          <p className="repeat-label" id="repeat-picker-title">
            Repeat every
          </p>
          <Select
            value={repeatWeek}
            onChange={onRepeatChange}
            renderValue={(selected) => {
              return selected;
            }}
            MenuProps={MenuProps}
            inputProps={{ "aria-label": "Without label" }}
            className="select-week-item"
            id="repeat-picker-selector"
          >
            {items.map((items) => (
              <MenuItem key={items} value={items} id="repeat-picker-menu-item">
                {items}
              </MenuItem>
            ))}
          </Select>
          <p className="weeks-label" id="repeat-picker-weeks">
            weeks
          </p>
        </div>
      </div>
    </>
  );
}
